module.exports = __webpack_public_path__ + "img/157.8ca98dba.jpg";